<template>
<div class="m-row" 
  ><slot></slot></div>
</template>
<script>
export default {
  name: 'MRow'
}
</script>


// WEBPACK FOOTER //
// src/m/container/row.vue